export const GET_JOURNEYS = 'GET_JOURNEYS';

// Get journeys (via saga)
export const getjourneys = (locations) => {
	return {
		type: 'GET_JOURNEYS',
		options: {
			locations
		}
	}
}

// Put journeys (from saga)
export const putjourneys = (journeys = []) => {
	return {
		type: 'PUT_JOURNEYS',
		payload: {
			journeys,
		}
	}
}

// Clear journeys
export const clearjourneys = (journeys = []) => {
	return {
		type: 'CLEAR_JOURNEYS',
		payload: {
			journeys,
		}
	}
}

// Set the current journey type - fastest, quietest, or balanced
export const setCurrent = (current = false) => {
	return {
		type: 'SET_CURRENT_JOURNEY',
		current
	}
}



// WEBPACK FOOTER //
// ./src/actions/journeys.js